import GODataKUPeriod from './GODataKUPeriod'

export default GODataKUPeriod
